import { render } from "./tagsForm.vue?vue&type=template&id=97ec5294&scoped=true"
import script from "./tagsForm.vue?vue&type=script&lang=js"
export * from "./tagsForm.vue?vue&type=script&lang=js"

import "./tagsForm.vue?vue&type=style&index=0&id=97ec5294&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ec5294"]])

export default __exports__